// 

import $ from 'jquery';
import { isObject } from '../object';
import Uri from 'urijs';


export const getNamesArray = (names, likeWidgetData) => {
  let namesForRemove = [];
  if (Array.isArray(names)) {
    namesForRemove = names;
  }
  if (typeof names === 'string') {
    namesForRemove = names.replace(/\s*[,;]\s*/g, ',')
      .split(',');
  }
  if (likeWidgetData) {
    namesForRemove = namesForRemove.map((name) => `frm.${name}`);
  }
  return namesForRemove;
};

/**
 * Remove all or defined data from form data object
 */
export const removeFromData = (
  data, remove,
  likeWidgetData,
) => {
  if (!remove) {
    return data;
  }
  if (remove === true) {
    return data.filter(
      (item) => likeWidgetData ? !item.name.startsWith('frm.') : (item.name.startsWith(
        'frm.') || item.name === 'formId'));
  }
  const forRemove = getNamesArray(remove, likeWidgetData);
  return data.filter((item) => !forRemove.includes(item.name));
};

/**
 * Serialize form data from more forms (elements) with data prevent duplicity
 */
export const serializeForms = (elements) => {
  let data = [];
  [...elements].forEach((element) => {
    const namesForRemove = data.map(({ name }) => name);
    const formData = removeFromData($(element).serializeArray(), namesForRemove);
    data = [...data, ...formData];
  });
  return data;
};

/**
 *  Maps object to objects array with pairs name and value
 */
export const mapToSubmitDataIfNeeded = (
  data,
) => {

  if (typeof data === 'string') {
    data = Uri.parseQuery(data);
  }

  if (isObject(data) && !Array.isArray(data)) {
    const transformedSubmitData = [];
    Object.keys(data)
      .forEach((name) => {
        const values = data[name];
        if (Array.isArray(values)) {
          values.forEach((value) => {
            transformedSubmitData.push({
              name,
              value,
            });
          });
        } else {
          transformedSubmitData.push({
            name,
            value: values,
          });
        }
      });
    return transformedSubmitData;
  }
  return data;
};

export const mergeSubmitData = (
  data1,
  data2,
) => {
  data1 = mapToSubmitDataIfNeeded(data1);
  data2 = mapToSubmitDataIfNeeded(data2);
  const submitDataMergeNames = data2.map(({ name }) => name);
  data1 = removeFromData(data1, submitDataMergeNames, false);
  return [...data1, ...data2];
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/lib/form/index.js